import * as THREE from 'three';

const vertexShader = /* glsl */ `
#include <common>
// #include <batching_pars_vertex>
#include <uv_pars_vertex>
// #include <envmap_pars_vertex>
#include <color_pars_vertex>
// #include <fog_pars_vertex>
// #include <morphtarget_pars_vertex>
// #include <skinning_pars_vertex>
// #include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>

void main() {

	#include <uv_vertex>
	#include <color_vertex>
	// #include <morphinstance_vertex>
	// #include <morphcolor_vertex>
	// #include <batching_vertex>

	// #if defined ( USE_ENVMAP ) || defined ( USE_SKINNING )

	// 	#include <beginnormal_vertex>
	// 	#include <morphnormal_vertex>
	// 	#include <skinbase_vertex>
	// 	#include <skinnormal_vertex>
	// 	#include <defaultnormal_vertex>

	// #endif

	#include <begin_vertex>
	// #include <morphtarget_vertex>
	// #include <skinning_vertex>
	#include <project_vertex>
	// #include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>

	#include <worldpos_vertex>
	// #include <envmap_vertex>
	// #include <fog_vertex>

}
`;

const fragmentShader = /* glsl */ `
#define USE_MAP

uniform vec3 diffuse;
uniform float opacity;

uniform float brightness;
uniform float contrast;

#ifndef FLAT_SHADED

	varying vec3 vNormal;

#endif

#include <common>
// #include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
// #include <alphamap_pars_fragment>
// #include <alphatest_pars_fragment>
// #include <alphahash_pars_fragment>
// #include <aomap_pars_fragment>
// #include <lightmap_pars_fragment>
// #include <envmap_common_pars_fragment>
// #include <envmap_pars_fragment>
// #include <fog_pars_fragment>
// #include <specularmap_pars_fragment>
// #include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>

void main() {

	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>

	// #include <logdepthbuf_fragment>

  // #include <map_fragment>
#ifdef USE_MAP

	vec4 sampledDiffuseColor = texture2D( map, vMapUv );

	#ifdef DECODE_VIDEO_TEXTURE

		// use inline sRGB decode until browsers properly support SRGB8_ALPHA8 with video textures (#26516)

		sampledDiffuseColor = sRGBTransferEOTF( sampledDiffuseColor );

	#endif

  sampledDiffuseColor.rgb += brightness;
  sampledDiffuseColor.rgb = (sampledDiffuseColor.rgb - 0.5) * contrast + 0.5;

  diffuseColor *= sampledDiffuseColor;

#endif

	#include <color_fragment>
	// #include <alphamap_fragment>
	// #include <alphatest_fragment>
	// #include <alphahash_fragment>
	// #include <specularmap_fragment>

	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );

	// accumulation (baked indirect lighting only)
	#ifdef USE_LIGHTMAP

		vec4 lightMapTexel = texture2D( lightMap, vLightMapUv );
		reflectedLight.indirectDiffuse += lightMapTexel.rgb * lightMapIntensity * RECIPROCAL_PI;

	#else

		reflectedLight.indirectDiffuse += vec3( 1.0 );

	#endif

	// modulation
	// #include <aomap_fragment>

	reflectedLight.indirectDiffuse *= diffuseColor.rgb;

	vec3 outgoingLight = reflectedLight.indirectDiffuse;

	// #include <envmap_fragment>

	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	// #include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	// #include <dithering_fragment>

}
`;

type Parameters = THREE.MaterialParameters & {
  map: THREE.Texture;
  brightness: number;
  contrast: number;
};

class ImageMaterial extends THREE.ShaderMaterial {
  public map: THREE.Texture;
  public brightness: number;
  public contrast: number;
  public color: THREE.Color;

  // public lightMap: THREE.Texture | null;
  // public lightMapIntensity: number;

  // public aoMap: THREE.Texture | null;
  // public aoMapIntensity: number;

  // public specularMap: THREE.Texture | null;
  // public alphaMap: THREE.Texture | null;

  // public envMap: THREE.Texture | null;
  // public envMapRotation: THREE.Euler;

  // public combine: THREE.Combine;

  // public reflectivity: number;
  // public refractionRatio: number;

  // public wireframeLinecap: string;
  // public wireframeLinejoin: string;

  constructor({ map, brightness, contrast, ...parameters }: Parameters) {
    super({
      ...parameters,
      vertexShader,
      fragmentShader,
      uniforms: {
        map: { value: map },
        brightness: { value: brightness },
        contrast: { value: contrast },
        diffuse: {
          value: new THREE.Color(0xffffff),
        },
        opacity: {
          value: parameters.opacity ?? 1,
        },
        mapTransform: {
          value:
            parameters.side === THREE.BackSide
              ? new THREE.Matrix3(-1, 0, 0, 0, 1, 0, 0, 0, 1)
              : new THREE.Matrix3(1, 0, 0, 0, 1, 0, 0, 0, 1),
        },
        // alphaMap: {
        //   value: null,
        // },
        // alphaMapTransform: {
        //   value: new THREE.Matrix3(1, 0, 0, 0, 1, 0, 0, 0, 1),
        // },
        // alphaTest: {
        //   value: 0,
        // },
        // specularMap: {
        //   value: null,
        // },
        // specularMapTransform: {
        //   value: new THREE.Matrix3(1, 0, 0, 0, 1, 0, 0, 0, 1),
        // },
        // envMap: {
        //   value: null,
        // },
        // envMapRotation: {
        //   value: new THREE.Matrix3(1, 0, 0, 0, 1, 0, 0, 0, 1),
        // },
        // flipEnvMap: {
        //   value: -1,
        // },
        // reflectivity: {
        //   value: 1,
        // },
        // ior: {
        //   value: 1.5,
        // },
        // refractionRatio: {
        //   value: 0.98,
        // },
        // aoMap: {
        //   value: null,
        // },
        // aoMapIntensity: {
        //   value: 1,
        // },
        // aoMapTransform: {
        //   value: new THREE.Matrix3(1, 0, 0, 0, 1, 0, 0, 0, 1),
        // },
        // lightMap: {
        //   value: null,
        // },
        // lightMapIntensity: {
        //   value: 1,
        // },
        // lightMapTransform: {
        //   value: new THREE.Matrix3(1, 0, 0, 0, 1, 0, 0, 0, 1),
        // },
        // fogDensity: {
        //   value: 0.00025,
        // },
        // fogNear: {
        //   value: 1,
        // },
        // fogFar: {
        //   value: 2000,
        // },
        // fogColor: {
        //   value: 16777215,
        // },
        // clippingPlanes: {
        //   value: null,
        // },
      },
    });

    this.map = map;
    this.brightness = brightness;
    this.contrast = contrast;

    // this.isMeshBasicMaterial = true;

    // this.type = 'MeshBasicMaterial';

    this.color = new THREE.Color(0xffffff); // emissive

    // this.lightMap = null;
    // this.lightMapIntensity = 1.0;

    // this.aoMap = null;
    // this.aoMapIntensity = 1.0;

    // this.specularMap = null;

    // this.alphaMap = null;

    // this.envMap = null;
    // this.envMapRotation = new THREE.Euler();

    // this.combine = THREE.MultiplyOperation;
    // this.reflectivity = 1;
    // this.refractionRatio = 0.98;

    // this.wireframe = false;
    // this.wireframeLinewidth = 1;
    // this.wireframeLinecap = 'round';
    // this.wireframeLinejoin = 'round';

    this.fog = false;

    this.setValues(parameters);
  }

  copy(source: ImageMaterial) {
    super.copy(source);

    this.color.copy(source.color);

    this.map = source.map;

    // this.lightMap = source.lightMap;
    // this.lightMapIntensity = source.lightMapIntensity;

    // this.aoMap = source.aoMap;
    // this.aoMapIntensity = source.aoMapIntensity;

    // this.specularMap = source.specularMap;

    // this.alphaMap = source.alphaMap;

    // this.envMap = source.envMap;
    // this.envMapRotation.copy(source.envMapRotation);
    // this.combine = source.combine;
    // this.reflectivity = source.reflectivity;
    // this.refractionRatio = source.refractionRatio;

    this.wireframe = source.wireframe;
    this.wireframeLinewidth = source.wireframeLinewidth;
    // this.wireframeLinecap = source.wireframeLinecap;
    // this.wireframeLinejoin = source.wireframeLinejoin;

    this.fog = source.fog;

    return this;
  }
}

export { ImageMaterial };
